import React, { useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";
import { useApp } from "@/context/AppContext";

// Shown once for new accounts created via Google login (age_confirmed === false).
export default function AgeGate() {
  const { user, t, refreshMe, logout } = useApp();
  const [checked, setChecked] = useState(false);
  const [busy, setBusy] = useState(false);
  if (!user || user.age_confirmed !== false) return null;
  const confirm = async () => {
    setBusy(true);
    try { await api.post("/auth/confirm-age"); await refreshMe(); }
    catch (err) { toast.error(err.response?.data?.detail || "Failed"); }
    finally { setBusy(false); }
  };
  const decline = async () => {
    setBusy(true);
    try { await api.delete("/auth/account"); } catch { /* account may already be gone */ }
    await logout();
  };
  return (
    <div className="fixed inset-0 z-[80] bg-foreground/60 flex items-center justify-center p-4" data-testid="age-gate">
      <div className="bg-background border border-foreground w-full max-w-md p-6">
        <div className="eyebrow text-primary">Soul Radar</div>
        <h2 className="font-display uppercase text-2xl leading-none mt-1">{t("ageGateTitle")}</h2>
        <p className="text-sm mt-3">{t("ageGateText")}</p>
        <label className="flex items-start gap-2 text-sm mt-4 min-h-[44px]">
          <input type="checkbox" className="w-4 h-4 mt-0.5 shrink-0" checked={checked} onChange={e => setChecked(e.target.checked)} data-testid="age-gate-checkbox" />
          <span>{t("ageConfirm")}</span>
        </label>
        <div className="mt-5 flex flex-wrap justify-end gap-2">
          <button onClick={decline} disabled={busy} className="gg-btn !py-2 !px-3 text-xs" data-testid="age-gate-decline">{t("ageGateDecline")}</button>
          <button onClick={confirm} disabled={!checked || busy} className="gg-btn-primary !py-2 !px-3 text-xs disabled:opacity-40" data-testid="age-gate-confirm">{t("confirm")}</button>
        </div>
      </div>
    </div>
  );
}
